import api, { userApi } from 'src/api';
import {
  GetEventInfoRequest,
  PostSellOpenRequest,
  PostSellOpenResponse,
  PostSellCloseRequest,
  PostEventRequest,
  PutSellEditRequest,
  PutSellEditResponse,
  PutSellBuyRequest,
  PutSellBuyResponse,
  PutSellPayRequest,
  PutSellPayResponse,
} from 'src/types/api';
import { EventPublicInfo } from 'src/types/dto';
import { useParams } from 'react-router-dom';
import { useCheckoutStore } from './stores';

export const useClearEventCart = () => {
  const { eventID } = useParams();
  
  return {
    clearEventCart: () => {
      if (eventID) {
        useCheckoutStore.getState().clearEventCheckout(eventID);
      }
    },
    eventID
  };
};

export const getEvent = ({ eventId, params }: GetEventInfoRequest) =>
  api.get<EventPublicInfo>(`eventinfo/${eventId}`, { params }).then(res => {
    return res.data;
  });

export const postSellOpen = ({ payload, params }: PostSellOpenRequest) =>
  userApi
    .post<PostSellOpenResponse>('sell/open', payload, { params })
    .then(res => res.data);

export const postSellClose = ({ sellId }: PostSellCloseRequest) =>
  userApi.post<void>(`sell/${sellId}/close`).then(res => res.data);

export const postEventMessage = ({ eventId, params }: PostEventRequest) =>
  userApi
    .post<void>(`event/${eventId}?message=${params.message}`, { params })
    .then(res => res.data);

export const putSellEdit = ({ sellId, payload, params }: PutSellEditRequest) =>
  userApi
    .put<PutSellEditResponse[]>(`sell/${sellId}/edit`, payload, { params })
    .then(res => res.data)
    .catch(error => {
      if (error.request && error.request.status === 403) {
        const urlPath = window.location.pathname;
        const match = urlPath.match(/\/event\/([^/]+)/);
        const eventID = match ? match[1] : null;
        if (eventID) {
          useCheckoutStore.getState().clearEventCheckout(eventID);
        }
      }
      throw error; 
    });
    ;
    export const putSellBuy = ({ sellId, payload, params }: PutSellBuyRequest) =>
      userApi
        .put<PutSellBuyResponse>(`/sell/${sellId}/buy`, payload, { params })
        .then(res => res.data);

// export const putSellBuy = ({ sellId, payload, params }: PutSellBuyRequest) =>
//   new Promise<PutSellBuyResponse>(resolve =>
//     resolve({
//       taxCCPixDiff: 0.1,
//       feePricePix: 10,
//       requireDocument: true,
//       requirePhone: true,
//     }),
//   );

export const putSellPay = ({
  sellId,
  payload,
  params,
  cancelToken,
}: PutSellPayRequest) =>
  userApi
    .put<PutSellPayResponse>(`/sell/${sellId}/pay`, payload, {
      params,
      cancelToken,
    })
    .then(res => res.data);
